exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._11RghWe2-SidebarNavLink-module-active{text-decoration:underline!important}._27VUKEJm-SidebarNavLink-module-spacing{padding-top:1px;padding-bottom:1px}", ""]);

// exports
exports.locals = {
	"active": "_11RghWe2-SidebarNavLink-module-active",
	"spacing": "_27VUKEJm-SidebarNavLink-module-spacing"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/Sidebar/SidebarNavLink.module.scss
// module id = 760
// module chunks = 0